import { render, staticRenderFns } from "./UserShortcutDialog.vue?vue&type=template&id=ef622fe0&scoped=true"
import script from "./UserShortcutDialog.vue?vue&type=script&lang=js"
export * from "./UserShortcutDialog.vue?vue&type=script&lang=js"
import style0 from "./UserShortcutDialog.vue?vue&type=style&index=0&id=ef622fe0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef622fe0",
  null
  
)

export default component.exports